import React from "react";

const IconChatBot = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="44"
        height="44"
        rx="22"
        fill="url(#paint0_radial_4058_8277)"
      />
      <path
        d="M23.25 6L9.73364 22.2196C8.6481 23.5223 9.57441 25.5 11.2701 25.5H21.625L20 38.5L33.5164 22.2804C34.6019 20.9777 33.6756 19 31.9799 19H21.625L23.25 6Z"
        fill="#29394D"
        stroke="#29394D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4058_8277"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22 22) rotate(90) scale(22)"
        >
          <stop stopColor="#18A0FB" />
          <stop offset="0.84" stopColor="#F4F7F9" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default IconChatBot;
